export default __webpack_public_path__ + "static/media/iconInfoDisabled16.a00b46dd.svg";